module.exports = __webpack_public_path__ + "static/media/TMT-CORT010-120-mobile.fc07fc31.jpg";